module.exports = __webpack_public_path__ + "img/notes-es.2710d419.png";